import { MealTime } from "@/clients/models/MealTime";
import { PageContainer } from "@/components/container/page-container";
import { PageTitleComponent } from "@/components/page-title";
import { useGetCandidates } from "@/hooks/requests/go-to/use-get-candidates";
import { IonSkeletonText, useIonRouter } from "@ionic/react";
import { useCallback } from "react";
import { useParams } from "react-router-dom";
import GoToMealSwiper from "../../components/meal-swiper/go-to-meal-swiper";

export default function FavouriteFoodProfilePlan() {
  const { mealTime } = useParams<{ mealTime: MealTime }>();
  const navigation = useIonRouter();
  const { candidates, isLoading } = useGetCandidates(mealTime);
  const currentCandidate = candidates?.[mealTime] ?? [];

  const onCompleted = useCallback(() => {
    const searchParams = new URLSearchParams();
    searchParams.set("mealTime", mealTime);
    navigation.push(`/profiling/favourites?${searchParams.toString()}`, "back");
  }, [mealTime]);

  return (
    <PageContainer
      className="app-bar-bottom-padding overflow-y-auto no-scrollbar"
      showLogo={true}
    >
      <PageTitleComponent
        title="My Top Picks"
        description="Based on your top picks, we think you'll love these. You can choose up to 2 favorites."
      />

      {isLoading ? (
        <div className="flex-1 w-full flex flex-col gap-4">
          <IonSkeletonText animated className="w-full h-[20rem]" />
          <IonSkeletonText animated className="w-full h-10" />
        </div>
      ) : (
        <GoToMealSwiper
          mealTime={mealTime}
          meals={currentCandidate}
          onCompleted={onCompleted}
        />
      )}
    </PageContainer>
  );
}
